import * as changeImgUrlProductDetail from './plugins/product-detail';
import * as branch from './plugins/branch';
import * as shareSocial from './plugins/share-cocial';
import * as modalDiscount from './plugins/show-modal-discount';
import * as sendOTP from './plugins/send-otp';
import * as AddToCart from './plugins/add-to-cart';
import * as Cart from './plugins/cart';
import * as Category from './plugins/category';
import * as AddToWishlist from './plugins/add-to-wishlist';
import * as Wishlist from './plugins/wishlist';
import * as Checkout from './plugins/checkout';
import * as Login from './plugins/login';
import * as LandingPage from './plugins/landing-page';

$(function () {
  Cart.init();
  changeImgUrlProductDetail.init();
  branch.init();
  modalDiscount.init();
  shareSocial.init();
  sendOTP.init();
  AddToCart.init();
  Category.init();
  AddToWishlist.init();
  Wishlist.init();
  Checkout.init();
  Login.init();
  LandingPage.init();
});



